import React, { useState } from "react";
import axios from "axios";
import "../../styles/plans.css";
import Modal from "../Modal/Modal";
import "../../styles/thankyou.css";
import { API_BASE_URL } from "../../config/config";

export default function PlansTable({ title, plans, type }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [formFields, setFormFields] = useState({
    name: "",
    company: "",
    job: "",
    email: "",
    phone: "",
    city: "",
  });

  const openModal = (plan) => {
    setDescription(
      `I want to enquire about the ${plan.title} plan.\n\n` +
        `Specs:\n` +
        `- CPU: ${plan.cpu || "-"}\n` +
        `- RAM: ${plan.ram || "-"} GB\n` +
        `- Storage: ${plan.storage} GB\n` +
        `- Bandwidth: ${plan.bandwidth}\n` +
        `- Price: ₹${plan.price}\n\n` +
        `Please provide more details.`
    );

    setSubmitted(false);
    setIsModalOpen(true);
  };

  const handleChange = (e) => {
    setFormFields({ ...formFields, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      Details: {
        name: formFields.name,
        email_address: formFields.email,
        comp_name: formFields.company,
        job_title: formFields.job,
        phone_no: formFields.phone,
        description: description,
        city: formFields.city,
        service_type: "cloud-plans",
      },
      token: "",
    };

    try {
      await axios.post(
        `${API_BASE_URL}/api/website/createColocationInquiry`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      setSubmitted(true);
    } catch (error) {
      console.error("API Error:", error);
      alert("Something went wrong. Try again!");
    }
  };

  return (
    <>
      <div className="table-heading">{title}</div>

      <div className="table-box">
        <div className="table-responsive">
          <table className="plans-table table-bordered">
            <thead>
              <tr>
                <th>Plan</th>
                {type === "storage-services" ? null : (
                  <>
                    <th>vCPUs</th>
                    <th>Memory (GB)</th>
                  </>
                )}
                <th>Storage (GB)</th>
                <th>Bandwidth</th>
                <th>Price (₹)</th>
                <th>Get Now</th>
              </tr>
            </thead>

            <tbody>
              {plans.length === 0 && (
                <tr className="mobile-card">
                  <td colSpan="7" className="text-center">
                    No plans found
                  </td>
                </tr>
              )}

              {plans.map((p) => (
                <tr key={p.id} className="mobile-card">
                  {/* Plan Title */}
                  <td data-label="Plan">{p.title}</td>

                  {/* CPU + RAM only for cloud-server-plans */}
                  {type === "storage-services" ? null : (
                    <>
                      <td data-label="vCPUs">{p.cpu}</td>
                      <td data-label="Memory (GB)">{p.ram}</td>
                    </>
                  )}

                  {/* Storage */}
                  <td data-label="Storage (GB)">{p.storage}</td>

                  {/* Bandwidth */}
                  <td data-label="Bandwidth">{p.bandwidth}</td>

                  {/* Price */}
                  <td data-label="Price (₹)">₹{p.price}</td>

                  {/* Buy Button */}
                  <td data-label="Get Now">
                    <button className="buy-btn" onClick={() => openModal(p)}>
                      {p.button_title || "Buy"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ===================== MODAL ===================== */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        {!submitted ? (
          <>
            <h2>Get In Touch</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formFields.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formFields.company}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="job"
                  placeholder="Job Title"
                  value={formFields.job}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formFields.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={formFields.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formFields.city}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <textarea
                  rows="4"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </form>
          </>
        ) : (
          // 🎉 THANK YOU ANIMATION SECTION
          <div className="thanks-msg">
            <div className="main-container">
              <div className="check-container">
                <div className="check-background">
                  <svg
                    viewBox="0 0 65 51"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 25L27.3077 44L58.5 7"
                      stroke="white"
                      strokeWidth="13"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="check-shadow"></div>
              </div>

              <h4>"Thank you - We'll be in touch shortly to assist you."</h4>

              <button
                className="submit-btn"
                onClick={() => setIsModalOpen(false)}
                style={{ marginTop: "15px" }}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
}
